import React, { Component } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles, Typography, Grid, Button, Paper, Chip, RadioGroup, FormControl, Card, CardContent, CardActions } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cx from 'classnames';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { TestTemplateBody } from '../types/TestTemplateBody';
import { TypeOfGoalBody } from '../types/TypeOfGoalBody';
import { TypeOfSubjectBody } from '../types/TypeOfSubjectBody';
import { ContentSubType } from '../types/ContentSubTypeBody';
import { getMasterTestTypeDisplayName, getPropertyValue, getSectionLevelDisplayName, toShowJEEMainSpecificFields } from '../../../utils';

const styles = (theme: Theme) => createStyles({
    root: {
        ...theme.mixins.gutters(),
        width: '100%',
        maxWidth: '100%'
    },
    paddingT: {
        paddingTop: theme.spacing.unit * 2,
    },
    textRight: {
        textAlign: 'right'
    },
    paperSection: {
        marginTop: theme.spacing.unit * 2,
        '&:first-child': {
            marginTop: `0px`,
        }
    },
    subSection: {
        "& span": {
            display: "inline-block",
            paddingLeft: "5px"
        }
    },
    paddingLeft: {
        paddingLeft: "5px"
    },
    paperSectionTitle: {
        padding: theme.spacing.unit * 2,
        backgroundColor: '#F4F8F9',
        borderBottom: 'solid 1px #D9D9D9'
    },
    paperSectionContent: {
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit * 2,
    },
    paperSectionContentInner: {
        marginTop: theme.spacing.unit * 2,
        padding: `${theme.spacing.unit * 2}px`,
        background: theme.palette.common.white,
        borderRadius: '2px',
        boxShadow: 'none',
        '&:not(:last-child)':{
            borderBottom: 'solid 1px #D9D9D9',
        },
        '&:first-child': {
            marginTop: `0px`,
        }
    },
    paperSubSectionQuestion: {
        paddingTop: theme.spacing.unit * 2,
        fontSize: '0.9rem'
    },
    fwNormal: {
        fontWeight: theme.typography.fontWeightRegular
    },
    subSectionTypeChip: {
        margin: '0 5px 5px 5px',
        height: '26px'
    },
    noCardShadow:{
        boxShadow: 'none',
        border: 'solid 1px #E6E6E6',
    },
    grayTxt:{
        color: '#666',
        fontSize: 14,
        marginTop: 6,
    },
    mb20:{
        marginBottom: 20,
    },
    yellowStrip:{
        backgroundColor: '#FFFCF2',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '20px 30px',
        margin: "-20px -25px 15px",
        width: "calc(100% + 50px)",
        '& p':{
            fontWeight: 400,
            color: '#666',
            maxWidth: "25%",
            wordWrap: "break-word",
            textWrap: "balance",
            '& b':{
                fontWeight: 500,
                color: '#333',
                display: 'block'
            }
        }
    }
});


interface ViewTemplateProps extends WithStyles<typeof styles> {
    typeOfGoal: TypeOfGoalBody[],
    contentSubType: ContentSubType[],
    typeOfSubject: TypeOfSubjectBody[]
    templateDetails: TestTemplateBody;
    activeTestType: any;
}

interface ViewTemplateState {
    durationType: string,
}

class ViewTemplate extends Component<ViewTemplateProps, ViewTemplateState>{

    constructor(props: ViewTemplateProps) {
        super(props);

        this.state = {
            durationType: "min",
        };
    }

    componentDidMount() {
    }

    getSubjectName(subjectId: string) {
        let s = this.props.typeOfSubject.filter(o => o._id == subjectId);
        return s && s.length > 0 ? s[0].name : "" || "";
    }

    getQuestionType(qT: number) {
        let q = this.props.contentSubType.filter(o => o.code == qT);
        return q && q.length > 0 ? q[0].name : "" || "";
    }

    getSectionName(section: any){
        /* if(section.autoPickSelection){
            return "Any Topic"
        }
        else */ if(_.get(section, "courseSyllabusId.name", "")){
            return _.get(section, "courseSyllabusId.name", "");
        }
        else if(section.name){
            return section.name
        }
        return "";
    }

    render() {
        const { classes, templateDetails,activeTestType } = this.props;
        const { durationType } = this.state;
        const showJEEMainSpecificFields = toShowJEEMainSpecificFields(templateDetails);
        const testSection = templateDetails.sections || [];
        const totalSubSection = testSection.reduce((total, section) => total + (section.subSection || []).length, 0);

        return (
            <>
                <Grid container className={classes.yellowStrip}>
                    <Typography>
                        <b>Test Type Name:</b>
                        {activeTestType && activeTestType.name}
                    </Typography>
                    <Typography>
                        <b>Summary:</b>
                        {testSection.length} Section{testSection.length != 1 ? 's' : ''}, {totalSubSection} Sub-section{totalSubSection !== 1 ? 's' : ''}
                    </Typography>
                    <Typography>
                        <b>Duration:</b>
                        {templateDetails.testDurationNumber} {templateDetails.testDurationType}
                    </Typography>
                    <Typography>
                        <b>Master Test Type:</b>
                        {getMasterTestTypeDisplayName(templateDetails.testTypeCode)}
                    </Typography>
                    <Typography>
                        <b>Section Level:</b>
                        {getSectionLevelDisplayName(templateDetails.testSectionLevel)}
                    </Typography>
                </Grid>
                {
                    _.map(templateDetails.sections, (filterData, i) => {
                        return (
                            <>
                            <Paper key={i} className={[classes.paperSection, classes.noCardShadow].join(' ')}>
                                <div className={classes.paperSectionTitle}>
                                    <Grid container>
                                        <Grid item xs>
                                            <Typography variant="h6" className={classes.fwNormal}>
                                                {this.getSectionName(filterData)}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto">
                                            <Typography variant="body2" className={[classes.fwNormal, classes.grayTxt].join(' ')}>
                                                Section Marks: {filterData.totalMarks}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </div>
                                <div className={classes.paperSectionContent}>
                                    {
                                        _.map(filterData.subSection, (subS, i) => {
                                            const { optionalQuestions, mandatoryQuestionCount, noOfQuestions } = subS;
                                            const noOfQuestionsToConsiderForMarks = optionalQuestions && mandatoryQuestionCount !== undefined ? mandatoryQuestionCount || 0 : noOfQuestions;
                                            return (
                                                <Paper key={i} className={classes.paperSectionContentInner} elevation={1}>
                                                    {/* Title */}
                                                    <Grid container className={classes.mb20}>
                                                        <Grid item xs>
                                                            <Typography variant="h6">
                                                                {subS.name}
                                                                {(
                                                                    <Chip color="primary" label={subS.optionalQuestions ? 'Optional' : 'Mandatory'} className={classes.subSectionTypeChip} variant="outlined" />
                                                                )}
                                                            </Typography>
                                                            
                                                        </Grid>
                                                        <Grid item xs="auto">
                                                            <Typography variant="body2" className={[classes.fwNormal, classes.grayTxt].join(' ')}>
                                                            Sub-Section Marks:{
                                                                    _.isInteger(noOfQuestionsToConsiderForMarks && subS.positiveMarks) ? (noOfQuestionsToConsiderForMarks * subS.positiveMarks) : 0
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>

                                                    {/* Question description */}
                                                    <Grid container>
                                                        <Grid item xs={4}>
                                                            <Typography variant="body2"  className={classes.fwNormal}>
                                                                <strong>Question Types: </strong>
                                                                {this.getQuestionType(subS.quesCodeAllowed)}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <Typography variant="body2"  className={classes.fwNormal}>
                                                                <strong>Positive Marks: </strong>
                                                                {
                                                                    subS.positiveMarks == 0 ? ` 0` : 
                                                                    ` +${subS.positiveMarks}`
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <Typography variant="body2"  className={classes.fwNormal}>
                                                                <strong>Negative Marks: </strong>
                                                                {
                                                                    subS.negativeMarks == 0 ? ` 0` : ` -${subS.negativeMarks}`
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                        {/* Partial Marks */}
                                                        <Grid item>
                                                            <Typography variant="body2"  className={classes.fwNormal}>
                                                                <strong>Partial Marks: </strong>
                                                                {
                                                                    subS.partialMarks > 0 ? subS.partialMarks : " 0"
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container style={{marginTop: '10px'}}>
                                                        <Grid item xs={4}>
                                                            <Typography variant="body2"  className={classes.fwNormal}>
                                                                <strong>Total Questions: </strong>
                                                                {subS.noOfQuestions}
                                                            </Typography>
                                                        </Grid>
                                                        {(
                                                            <Grid item xs={4}>
                                                                <Typography variant="body2"  className={classes.fwNormal}>
                                                                    <strong>Mandatory Questions: </strong>
                                                                    {(subS.mandatoryQuestionCount === undefined ? subS.noOfQuestions : subS.mandatoryQuestionCount)}
                                                                </Typography>
                                                            </Grid>
                                                        )}
                                                    </Grid>

                                                    <Grid container style={{marginTop: '20px'}}>
                                                        <Grid item>
                                                            <Typography  variant="body2"  className={classes.fwNormal} component="div">
                                                                <strong>Instruction</strong>
                                                                <div>
                                                                    {
                                                                        !_.isEmpty(subS.instruction) ? subS.instruction : "-"
                                                                    }
                                                                </div>
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Paper>


                                            )
                                        })
                                    }
                                </div>
                            </Paper>
                            </>
                        )
                    })
                }
            </>
        );
    }
}

const mapStateToProps = (state: any) => ({
    // map state to props here
    typeOfGoal: _.get(state, 'testTemplate.goal.list', {}),
    typeOfSubject: _.get(state, 'testTemplate.subject.list', {}),
    contentSubType: _.get(state, 'testTemplate.contentSubType.list', {}),
    activeTestType: getPropertyValue(state, 'testTemplate.testTemplateType.activeTestType', {}),
}
);

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
    },
    dispatch
);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ViewTemplate));